import React from 'react';

import Popover from '@material-ui/core/Popover';

import { useStyles } from './styles';

const ListPopover = ({ children, list, maxWidth }) => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handlePopoverOpen = event => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <div style={{ display: 'inline' }}>
      <div
        className={classes.children}
        aria-owns={open ? 'mouse-over-popover-wrapper' : undefined}
        aria-haspopup="true"
        onMouseEnter={handlePopoverOpen}
        onMouseLeave={handlePopoverClose}
      >
        {children}
      </div>

      <Popover
        id="mouse-over-popover"
        className={classes.popover}
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center'
        }}
        onClose={handlePopoverClose}
        disableRestoreFocus
        PaperProps={{ style: { maxWidth } }}
      >
        <div className={classes.listContainer}>{list}</div>
      </Popover>
    </div>
  );
};

export default ListPopover;
